import messages from './cmsCreate.json' with { type: 'json' };

export const cmsCreateEn: Readonly<typeof messages> = messages;
